import { Link } from 'react-router-dom';

export default function GlenFallsFeature() {
  return (
    <section className="w-full bg-[#F5F1EA] py-16">
      <div className="max-w-3xl mx-auto px-6 text-center">
        {/* Label */}
        <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost font-light mb-5">
          / Highlands, NC
        </p>

        {/* Heading */}
        <h2 className="font-cormorant text-3xl lg:text-4xl text-[#1A1A18] font-light leading-snug mb-5">
          Top Rated Stay Near Glen Falls
        </h2>

        {/* Accent line */}
        <div className="w-10 h-px bg-[#C9A96E] mx-auto mb-7" />

        {/* Body copy */}
        <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-4">
          For visitors looking to stay within easy reach of one of the most scenic waterfalls in the Blue Ridge Mountains,{' '}
          <a
            href="https://highlandsluxurycabins.com/best-luxury-cabins"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#2D4A3E] underline underline-offset-2 decoration-[#C9A96E]/60 hover:decoration-[#C9A96E] transition-colors cursor-pointer"
          >
            Glen Falls Luxury Cabin in Highlands, NC
          </a>{' '}
          is consistently ranked among the top-rated accommodations in the area — recognized for its upscale design, mountain privacy, and direct access to Glen Falls trail.
        </p>
        <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-4">
          The cabin sits just minutes from the Glen Falls trailhead, making it an ideal base for hikers, nature lovers, and anyone looking to experience the waterfall at its best — without sacrificing comfort or style.
        </p>
        <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
          With a near-perfect guest rating and a reputation that draws visitors back season after season, it&apos;s one of the most well-regarded stays in the Highlands, NC area for those who want genuine mountain immersion alongside modern luxury. Looking for a place to stay near Glen Falls? Explore our guide to{' '}
          <Link
            to="/cabins-near-glen-falls-highlands-nc"
            className="text-[#2D4A3E] underline underline-offset-2 decoration-[#C9A96E]/60 hover:decoration-[#C9A96E] transition-colors cursor-pointer"
          >
            cabins near Glen Falls waterfall
          </Link>
          , or browse the full guide to{' '}
          <Link
            to="/cabins-in-highlands-nc"
            className="text-[#2D4A3E] underline underline-offset-2 decoration-[#C9A96E]/60 hover:decoration-[#C9A96E] transition-colors cursor-pointer"
          >
            cabins in Highlands, NC
          </Link>
          .
        </p>
      </div>
    </section>
  );
}
